import { useState, useRef } from "react";
import { TextField, Button, Box, Typography, Card, CardContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";

const ContactPage = () => {
  const { t } = useTranslation();

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  const [captchaValid, setCaptchaValid] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const recaptchaRef = useRef();

  const handleCaptchaChange = (value) => {
    setCaptchaValid(!!value);
    setCaptchaValue(value);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validare câmpuri
    if (!form.firstName || !form.lastName || !form.email || !form.message) {
      alert(t("contact.requiredFields"));
      return;
    }

    // Validare reCAPTCHA
    if (!captchaValid) {
      alert(t("contact.captchaError"));
      return;
    }

    try {
      const response = await fetch(
        "https://sendemail-3ltixhkucq-ew.a.run.app", // înlocuiește cu URL-ul funcției tale GCP
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...form, captchaToken: captchaValue }),
        }
      );

      if (response.ok) {
        alert(t("contact.successMessage"));
        setForm({ firstName: "", lastName: "", email: "", message: "" });
        setCaptchaValid(false);
        setCaptchaValue(null);
        recaptchaRef.current.reset();
      } else {
        alert(t("contact.errorMessage"));
      }
    } catch (error) {
      alert("Network error: " + error.message);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "94.99vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(-45deg, #1976d2, #1565c0, #0d47a1, #42a5f5)",
        backgroundSize: "400% 400%",
        animation: "gradientAnimation 15s ease infinite",
        color: "#fff",
        "@keyframes gradientAnimation": {
          "0%": { backgroundPosition: "0% 50%" },
          "50%": { backgroundPosition: "100% 50%" },
          "100%": { backgroundPosition: "0% 50%" },
        },
        p: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: "700px",
          backgroundColor: "rgba(255,255,255,0.12)",
          backdropFilter: "blur(12px)",
          color: "#fff",
          borderRadius: 4,
          boxShadow: "0 8px 30px rgba(0,0,0,0.4)",
        }}
      >
        <CardContent>
          <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: "bold" }}>
            {t("contact.title")}
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              marginTop: 3,
            }}
          >
            <TextField
              label={t("contact.firstName")}
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ style: { color: "#fff" } }}
              InputProps={{ style: { color: "#fff", backgroundColor: "rgba(255,255,255,0.1)" } }}
            />
            <TextField
              label={t("contact.lastName")}
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ style: { color: "#fff" } }}
              InputProps={{ style: { color: "#fff", backgroundColor: "rgba(255,255,255,0.1)" } }}
            />
            <TextField
              label={t("contact.email")}
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ style: { color: "#fff" } }}
              InputProps={{ style: { color: "#fff", backgroundColor: "rgba(255,255,255,0.1)" } }}
            />
            <TextField
              label={t("contact.message")}
              name="message"
              multiline
              rows={4}
              value={form.message}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ style: { color: "#fff" } }}
              InputProps={{ style: { color: "#fff", backgroundColor: "rgba(255,255,255,0.1)" } }}
            />

            {/* reCAPTCHA */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6LeyDt4rAAAAAHW1CDzf8-VrtbLjaU4-tM_XD_3X"
                onChange={handleCaptchaChange}
              />
            </Box>

            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{
                mt: 2,
                background: "linear-gradient(90deg, #42a5f5, #1976d2)",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: "30px",
                py: 1.5,
                boxShadow: "0 6px 15px rgba(0,0,0,0.3)",
                "&:hover": {
                  background: "linear-gradient(90deg, #64b5f6, #2196f3)",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.5)",
                },
              }}
            >
              {t("contact.submit")}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ContactPage;
